const PortalConsumerTags = {
  HasSeenPulseIntroModal: 'portal.consumer-has-seen-pulse-intro-modal',
  HasSeenWelcomeModal: 'portal.consumer-has-seen-welcome-modal',
  HasSeenAlignPaydayModal: 'portal.consumer-has-seen-align-payday-modal',
  HasSeenAlignPaydayTag: 'portal.consumer-has-seen-align-payday-tag',
  HasSeenPaymentTypesExperimentB: 'portal.consumer-has-seen-payment-types-experiment-b',
} as const
type PortalConsumerTag = (typeof PortalConsumerTags)[keyof typeof PortalConsumerTags]

const CheckoutConsumerTags = {} as const
type CheckoutConsumerTag = (typeof CheckoutConsumerTags)[keyof typeof CheckoutConsumerTags]

const CommonConsumerTags = {} as const
type CommonConsumerTag = (typeof CommonConsumerTags)[keyof typeof CommonConsumerTags]

type ConsumerTag = PortalConsumerTag | CheckoutConsumerTag | CommonConsumerTag

export type ConsumerTags = ConsumerTag[]

export type ConsumerTagsWithData =
  | {
      [key in ConsumerTag]: string
    }
  | {}

export type GetConsumerTagsResponseBody = ConsumerTags

export type GetConsumerTagsWithDataResponseBody = Array<{ key: ConsumerTag; value: string }>

export interface PostConsumerTagsRequest {
  body: { name: ConsumerTag; data?: string }
}

export interface PutConsumerTagsRequest {
  body: { name: ConsumerTag; data?: string }
}
